module.exports = __webpack_public_path__ + "img/icone-busca.04706d7e.svg";